export const AuthenticationBaseLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div className="grid min-h-svh w-full grid-cols-1 lg:h-screen lg:w-screen lg:grid-cols-2">
      <div className="flex flex-col items-center justify-center px-4 py-10 lg:p-0">
        <div className="flex items-center justify-center mb-9">
          <img src="/logo.png" alt="Zeos logo" width={173} height={139} />
        </div>
        {children}
      </div>
      <div className="hidden h-screen w-full bg-gray-100 lg:block">
        <img
          className="h-full w-full object-cover"
          src="/zeos_cover_cart.jpg"
          alt="Zeos cart"
        />
      </div>
    </div>
  );
};
